import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { Button, CheckboxLabel, TextField, Typography } from "@bookips/sds";
import { useEffect, useState } from "react";
export const CURRENCY_UNIT = 10;
// 10원 단위 절삭
export const roundDownToUnit = function(amount) {
    let unit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CURRENCY_UNIT;
    return Math.floor(amount / unit) * unit;
};
const CashPointUseRow = (param)=>{
    let { type , title , orderType , value , placeholder , buttonText , isNotAvailablePoint , onlyUnusableProducts , onValueChange , currentValue , maxValue , myOwnValue , options , valueColor  } = param;
    const [inputValue, setInputValue] = useState("");
    const isAvailableBalance = (value)=>value >= CURRENCY_UNIT;
    const handleTextChange = (e)=>{
        const numericValue = e.target.value.replace(/[^0-9]/g, "");
        const num = Number(numericValue) || 0;
        const finalValue = Math.min(num, maxValue !== null && maxValue !== void 0 ? maxValue : Infinity);
        const formattedValue = numericValue ? finalValue.toLocaleString() : "";
        setInputValue(formattedValue);
        onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(finalValue);
    };
    const handleBlur = ()=>{
        const adjustedAmount = roundDownToUnit(Number(inputValue.replace(/[^0-9]/g, "")) || 0);
        setInputValue(adjustedAmount > 0 ? adjustedAmount.toLocaleString() : "");
        onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(adjustedAmount);
    };
    const applyFullAmount = ()=>{
        if (maxValue < 0) {
            setInputValue("");
            onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(0);
            return;
        }
        const maxAvailable = roundDownToUnit(maxValue);
        const myAvailableValue = roundDownToUnit(myOwnValue !== null && myOwnValue !== void 0 ? myOwnValue : 0);
        const finalValue = Math.min(myAvailableValue, maxAvailable);
        setInputValue(finalValue.toLocaleString());
        onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(finalValue);
    };
    const handleAllUseClick = ()=>{
        // mx-324
        mixpanelEvent("UseAll Option Clicked", {
            Target: type,
            "Order Type": orderType
        });
        applyFullAmount();
    };
    useEffect(()=>{
        setInputValue(currentValue > 0 ? currentValue.toLocaleString() : "");
    }, [
        currentValue
    ]);
    useEffect(()=>{
        if (!(options === null || options === void 0 ? void 0 : options.isAlwaysUsedChecked) || maxValue <= 0 || myOwnValue <= 0) return;
        applyFullAmount();
    }, [
        options === null || options === void 0 ? void 0 : options.isAlwaysUsedChecked,
        maxValue,
        myOwnValue
    ]);
    var _options_isAlwaysUsedChecked;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-start justify-between max-sm:flex-col max-sm:gap-3",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-2 py-2 max-sm:gap-1.5 max-sm:py-0",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "body1",
                        className: "min-w-[100px] max-sm:min-w-0",
                        children: title
                    }),
                    /*#__PURE__*/ _jsxs(Typography, {
                        variant: "subtitle1",
                        className: cn(valueColor),
                        children: [
                            myOwnValue.toLocaleString(),
                            "원"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-2 max-sm:w-full",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center space-x-2 input-text-end",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "relative w-[280px] max-sm:w-full",
                                children: [
                                    /*#__PURE__*/ _jsx(TextField, {
                                        placeholder: placeholder,
                                        size: "lg",
                                        className: cn("w-full !text-end placeholder:!text-end", inputValue && "pr-7"),
                                        disabled: !isAvailableBalance(value) || isNotAvailablePoint,
                                        value: inputValue,
                                        onChange: handleTextChange,
                                        onBlur: handleBlur,
                                        onClick: ()=>{
                                            // mx-325
                                            mixpanelEvent("Textinput UI Clicked", {
                                                "Input Type": type + "_input",
                                                "Order Type": orderType
                                            });
                                        }
                                    }),
                                    inputValue && /*#__PURE__*/ _jsx("span", {
                                        className: "absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-600",
                                        children: "원"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "stroke",
                                color: "secondary",
                                className: "w-fit",
                                size: "lg",
                                onClick: handleAllUseClick,
                                disabled: !isAvailableBalance(value) || isNotAvailablePoint,
                                children: buttonText
                            })
                        ]
                    }),
                    (options === null || options === void 0 ? void 0 : options.isAlwaysUseCheckbox) && /*#__PURE__*/ _jsx(CheckboxLabel, {
                        checked: (_options_isAlwaysUsedChecked = options === null || options === void 0 ? void 0 : options.isAlwaysUsedChecked) !== null && _options_isAlwaysUsedChecked !== void 0 ? _options_isAlwaysUsedChecked : false,
                        onCheckedChange: (e)=>{
                            var _options_onAlwaysUseChange;
                            options === null || options === void 0 ? void 0 : (_options_onAlwaysUseChange = options.onAlwaysUseChange) === null || _options_onAlwaysUseChange === void 0 ? void 0 : _options_onAlwaysUseChange.call(options, Boolean(e));
                            if (e) {
                                // mx-324
                                mixpanelEvent("UseAll Option Clicked", {
                                    Target: "always",
                                    "Order Type": orderType
                                });
                            }
                        },
                        disabled: !isAvailableBalance(value),
                        classes: {
                            root: "w-fit"
                        },
                        children: "항상 전액 사용"
                    }),
                    onlyUnusableProducts && type === "point" && /*#__PURE__*/ _jsx(Typography, {
                        variant: "body2",
                        color: "primary",
                        children: "포인트 사용이 불가한 상품이에요."
                    })
                ]
            })
        ]
    });
};
export default CashPointUseRow;
